import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import useApiUrls from "../../useApiUrls";

const AddMerchant = () => {
  const navigate = useNavigate();
  const { getUrlByOperation } = useApiUrls();

  const [formData, setFormData] = useState({
    posname: "",
    merchantid: "",
    storeid: "",
    key: "",
    remark: "",
    serialno: "",
    active: true,
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId");
      setMessage("Authentication failed!");
      return;
    }

    try {
      const PosInsert = getUrlByOperation("posInsert");

      const generatedKey = generateGuidWithoutDashes();
      const payload = {
        ...formData,
        key: generatedKey,
      };

      const response = await axios.post(PosInsert, payload, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json",
        },
      });

      console.log("API Response:", response.data);

      // SUCCESS but API says FAIL
      if (response.data?.isresponse === false) {
        setMessage(response.data?.errormsg || "Failed to add data.");
        return;
      }

      // True success
      setMessage("Data added successfully!");

      setTimeout(() => {
        navigate("/merchantList");
      }, 3000);

    } catch (error) {
      console.error("API Error:", error);

      const apiError =
        error?.response?.data?.errormsg || "Failed to add data.";

      setMessage(apiError);
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Add Merchant</h3>
                    </div>

                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Pos Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.posname}
                                onChange={handleChange}
                                name="posname"
                                placeholder="Enter..."
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Merchant Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.merchantid}
                                onChange={handleChange}
                                name="merchantid"
                                placeholder="Enter..."
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Store ID</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.storeid}
                                onChange={handleChange}
                                name="storeid"
                                placeholder="Enter..."
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Remark</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.remark}
                                onChange={handleChange}
                                name="remark"
                                placeholder="Enter..."
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Active</label>
                              <select
                                className="form-control"
                                name="active"
                                value={formData.active}
                                onChange={handleChange}
                              >
                                <option value={true}>Active</option>
                                <option value={false}>Deactive</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                             <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info"
                          >
                            Add
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>

                  {/* SUCCESS MESSAGE */}
                  {message === "Data added successfully!" && (
                    <SuccessMessage message={message} />
                  )}

                  {/* ERROR MESSAGE */}
                  {message &&
                    message !== "Data added successfully!" && (
                      <FailedMessage message={message} />
                    )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default AddMerchant;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

function generateGuidWithoutDashes() {
  if (typeof window !== "undefined" && window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID().replace(/-/g, "");
  }
  return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
